import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import arch1 from './assets/images/arch1.png';
import compass from './assets/images/compass.png';


const ReactLesson6 = () => {
  const [language, changeLanguage] = useState("react");
  const [lineNumbers, toggleLineNumbers] = useState(false);
    const code = (
      'text',
      `
      import React from 'react';
      import ReactDom from 'react-dom/client':
      import './index.css':
      import App from './App':
      import reportWebVitals from './reportWebVitals':

      const root = ReactDom.createRoot(document.getElementById('root'));
      root.render(
        <React.StrictMode>
        <App />
        </React.StrictMode>
      );

      //if you want to start measuring performance in your app, pass a function
      //to log results (for example: reportWebVitals(console.log))
      //or send to an analytics endpoint. Learn more: //bit.ly/CRA-vitals
      reportWebVitals();
      `
    );



  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <p>The architecture of a React project involves organizing the codebase, files, and folders in a structured manner to create a scalable, maintainable, and easily understandable application. React itself doesn't enforce a specific architecture, but there are common practices and patterns followed by developers. Here's an outline of a typical React project architecture:</p>
      <ol class="list-group list-group-numbered mb-4">
         <li class="list-group-item"><strong>Folder Structure:</strong>
         <ol class="list-group list-group-numbered">
            <li class="list-group-item"><strong>src/</strong>: The main source directory containing all the application code. This is created by default</li>
            <li class="list-group-item"><strong>components/</strong>: Holds reusable UI components.</li>
            <li class="list-group-item"><strong>pages/</strong>: Contains higher-level components representing different pages or views of the application.</li>
            <li class="list-group-item"><strong>assets/</strong>: Stores static files like images, fonts, and CSS.</li>
            <li class="list-group-item"><strong>services/</strong>: Handles API calls and data fetching logic.</li>
            <li class="list-group-item"><strong>context/</strong>: Contains React context providers if using the Context API for state management.</li>
            <li class="list-group-item"><strong>hooks/</strong>: Custom React hooks used for state management or other purposes.</li>
            <li class="list-group-item"><strong>constants/</strong>: Stores constant values or configurations used across the app.</li>
         </ol>
         </li>
         <li class="list-group-item"><strong>Entry Points:</strong>
          <ol class="list-group list-group-numbered">
            <li class="list-group-item"><strong>index.js:</strong>: The main entry point of the application where the ReactDOM renders the root component into the HTML. This is where you set the component to load first when the application starts, which is by default the <strong>App.js</strong>. You can modify the file to load whichever component of your choice.
            <ol>
                <p class="mt-2 mb-2">This is what the <strong>index.js</strong></p>
                <CopyBlock
                        language={"react"}
                        text={code} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />            </ol>
            </li>
            <li class="list-group-item"><strong>App.js (or App.jsx):</strong> The root component of the application that houses the entire component tree.</li>
            </ol>
         </li>
         <li class="list-group-item"><strong>Component-Based Architecture:</strong>
         <ol class="list-group list-group-numbered">
             <li class="list-group-item"><strong>Components:</strong> Break the UI into reusable components, such as functional components or class-based components, each handling a specific part of the UI.</li>
             {/* <img class="img-fluid mb-2" style={{width: '500px', height: '350px'}} src={compass} alt="react" /> */}

             <li class="list-group-item"><strong>Container Components:</strong> Higher-level components that manage the state and pass data down to presentational components.</li>
         </ol>
         </li>
          <li class="list-group-item"><strong>Routing:</strong>
          <ol class="list-group list-group-numbered">
             <li class="list-group-item"><strong>React Router:</strong> If using client-side routing, define routes in the app to navigate between different views or pages.</li>
             <li class="list-group-item">Create a Routes.js or similar file to configure routes and link them to respective components.</li>
          </ol>
          </li>
          <li class="list-group-item"><strong>State Management:</strong>
          <ol class="list-group list-group-numbered">
              <li class="list-group-item"><strong>Local State:</strong> Utilize the useState hook for managing local component state.</li>
              <li class="list-group-item"><strong>State Management Libraries:</strong> Implement libraries like Redux, Context API, or MobX for global state management based on application complexity and needs.</li>
          </ol>
          </li>
           <li class="list-group-item"><strong>API Calls and Data Handling:</strong>
           <ol class="list-group list-group-numbered">
              <li class="list-group-item"><strong>Services:</strong> Create separate service files for API calls and data handling to separate concerns and ensure a cleaner codebase.</li>
              <li class="list-group-item"><strong>Axios or Fetch:</strong> Use libraries like Axios or the native Fetch API for making HTTP requests.</li>
          </ol>
          </li>
          <li class="list-group-item"><strong>Styling:</strong>
          <ol class="list-group list-group-numbered">
              <li class="list-group-item">Use CSS, SCSS, or CSS-in-JS solutions like styled-components or Emotion or Bootstrap for styling components.</li>
              <li class="list-group-item">Separate styles for components, pages, or global styles using appropriate folder structures.</li>
          </ol>
          </li>
      </ol>
      <h3><strong>Summary</strong></h3>
      <p>When it comes project architecture, there are no hard or fast rules or any defined structure. Depending on the project's scale, complexity, and team preferences, the folder structure and architectural patterns may vary. It's crucial to adapt the architecture to suit the specific requirements and needs of the project while ensuring consistency and scalability in development.</p>
  
  </div>
    

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson6